import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchUserPlayingHistory = async (token) => {
  const res = await axios.get(`${baseUrl}/api/participantProfile/playing_history/?portal=${portal}`, {
    headers: { Authorization: `Token ${token}` }
  });
  return res.data;
}